module.exports = __webpack_public_path__ + "assets/images/avatar_doencas_cronicas.adb15f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/avatar_doencas_cronicas.png
// module id = 678
// module chunks = 1